// import hooks
import { useTranslation } from "react-i18next";

import useCopyToClipboard from "../../utils/custom-hooks/useCopyToClipboard";

// import { t } from "i18next";

// import components

// import assets

// import data

const Order = ({ item }) => {
    const [t] = useTranslation("global");
    const [, copy] = useCopyToClipboard();
    // const windowWidth = useWindowSize();
    return (
        <>
            <div
                className="order-summary-item product-section-div flex-start-col"
                key={item.id}
            >
                <div className="order-summary-item-top flex-start-row">
                    <img className="order-summary-item-img" src={item.img} alt="" />
                    <div className="order-summary-item-top-txt flex-start-col">
                        <h2 className="ocean-h2">{item.name}</h2>
                        {item.store && (
                            <p className="order-summary-store flex-start-row">
                                <img src={item.storeFlag} alt="" />
                                <span>{item.store}</span>
                            </p>
                        )}
                        <p className="wishlist-counter ocean-p-grey ocean-p-700">{`${t(
                            "account.count"
                        )} ${item.count}`}</p>
                    </div>
                </div>

                <div className="card-code-div flex-start-row">
                    <span className="blue-txt ocean-p-700">{t("account.order.card-code")}:</span>
                    <div className="card-code flex-start-row" onClick={() => copy(item.cardCode)}>
                        <span className="blue-txt ocean-p-700">{item.cardCode}</span>
                        <div className="copy-div flex-start-row">
                            <div className="copy-svg ocean-svg"></div>{" "}
                            {t("account.order.copy")}
                        </div>
                    </div>
                </div>

                <p className="serial-div ocean-p-700">
                    {`${t("account.order.serial-num")}: ${item.serial}`}
                </p>
            </div>
        </>
    );
};

export default Order;
